import {
    PATH_CONTACTUS,
    PATH_PREFERENCECENTRE,
    PATH_UPCOMINGMODELS,
    PATH_UPCOMINGMODEL,
    PATH_UPCOMINGMODEL_DEALER,
    PATH_REQUEST_TESTDRIVE,
    PATH_REQUEST_QUOTE,
    PATH_ADE_RYI,
    PATH_ADE_BROCHURE,
    PATH_ADE_WAITLIST,
    PATH_PRICECALCULATOR,
    PATH_STARTPRICECALCULATOR,
    PATH_FINANCE_PRICE_CALCULATOR,
    PATH_FINANCE_BUDGET_CALCULATOR,
    PATH_SERVICE_PLAN_CALCULATOR,
    PATH_SERVICE_PRICE,
    PATH_XTIME,
    PATH_XTIME_DEALER,
    PATH_AFS_FEEDBACK,
    PATH_AFS_ENQUIRY,
    PATH_AFS_FLEET_ENQUIRY,
    PATH_AFS_CALCULATOR,
    PATH_CHANGE_VEHICLE_OWNER,
    PATH_DEALER_OFFER,
    PATH_F1_ENQUIRY,
    PATH_RECALL_TAKATA,
    PATH_LOCATEADEALER,
    PATH_LOCATEAREPAIRCENTRE,
    PATH_LOCATETRADEPART,
    PATH_BUY_SERVICE_PLAN,
    PATH_TRADEIN,
    PATH_EV_RYI,
    PATH_3G,
    PATH_REGISTERED,
    PATH_THANKS
} from './constants';

import ContactUs from './pages/ContactUs';
import PreferenceCentre from './pages/PreferenceCentre';
import UpcomingModels from './pages/UpcomingModels'; import {fetchRYIVariants} from './redux/Models';
import RequestTestDrive from './pages/RequestTestDrive';
import RequestQuote from './pages/RequestQuote';
import ADERegisterInterest from './pages/ADERegisterInterest';
import ADERequestBrochure from './pages/ADERequestBrochure';
import ADEWaitlist from './pages/ADEWaitlist';
import PriceCalculator from './pages/calculators/PriceCalculator';
import FinancePriceCalculator from './pages/calculators/FinancePriceCalculator';
import BudgetCalculator from './pages/calculators/BudgetCalculator';
import ServicePlanCalculator from './pages/ServicePlanCalculator';
import ServicePlanPrice from './pages/ServicePlanPrice';
import BookAService from './pages/BookAService';
import AFSEnquiry from './pages/afs/AFSEnquiry';
import AFSFleetEnquiry from './pages/afs/AFSFleetEnquiry';
import AFSFeedback from './pages/afs/AFSFeedback';
import AFSCalculator from './pages/afs/AFSCalculator';
import ChangeVehicleOwner from './pages/ChangeVehicleOwner';
import DealerOffer from './pages/DealerOffer';
import F1Enquiry from './pages/F1Enquiry';
import RecallForm from './pages/recall/RecallForm';
import LocateADealer from './pages/locate/LocateADealer';
import LocateARepairer from './pages/locate/LocateARepairer';
import LocateTradePart from './pages/locate/LocateTradePart';
import DynamicForm from './pages/DynamicForm';
import VideoWidget from './pages/VideoWidget';
import BuyServicePlan from './pages/BuyServicePlan';
import TradeIn from './pages/TradeIn';
import EVRegisterInterest from './pages/EVRegisterInterest';
import ThreeG from './pages/ThreeG';
import F1RyiForm from "./pages/UpcomingModels/F1RYIForm";

const routeConfig = [
    {
        path: PATH_CONTACTUS,
        component: ContactUs
    },
    {
        path: `${PATH_PREFERENCECENTRE}/:user?`,
        component: PreferenceCentre
    },
    {
        path: PATH_REQUEST_TESTDRIVE,
        component: RequestTestDrive
    },
    {
        path: `${PATH_REQUEST_QUOTE}/:audicode`,
        component: RequestQuote
    },
    {
        path: [`${PATH_ADE_RYI}/:program?`],
        component: ADERegisterInterest
    },
    {
        path: PATH_ADE_BROCHURE,
        component: ADERequestBrochure
    },
    {
        path: `${PATH_ADE_WAITLIST}/:expId`,
        component: ADEWaitlist
    },
    {
        path: [`${PATH_UPCOMINGMODELS}${PATH_THANKS}`, `${PATH_UPCOMINGMODELS}/:variant?`, `${PATH_UPCOMINGMODELS}`, `${PATH_UPCOMINGMODEL}/:variant?`, `${PATH_UPCOMINGMODEL_DEALER}/:variant?`],
        component: UpcomingModels,
        loadData: (dispatch, matchParams, query) => { return dispatch(fetchRYIVariants(matchParams.variant)); }
    },
    {
        path: [PATH_PRICECALCULATOR, PATH_STARTPRICECALCULATOR],
        component: PriceCalculator
    },
    {
        path: [PATH_FINANCE_PRICE_CALCULATOR],
        component: FinancePriceCalculator
    },
    {
      path: PATH_FINANCE_BUDGET_CALCULATOR,
      component: BudgetCalculator
    },
    {
        path: PATH_SERVICE_PLAN_CALCULATOR,
        component: ServicePlanCalculator
    },
    {
      path: PATH_SERVICE_PRICE,
      component: ServicePlanPrice
    },
    {
        path: [`${PATH_XTIME}/:dealer?/:locationId?`, `${PATH_XTIME_DEALER}/:dealer?/:locationId?`],
        component: BookAService
    },
    {
        path: PATH_AFS_ENQUIRY,
        component: AFSEnquiry
    },
    {
        path: [PATH_AFS_FLEET_ENQUIRY, `${PATH_AFS_FLEET_ENQUIRY}${PATH_THANKS}`],
        component: AFSFleetEnquiry
    },
    {
        path: [PATH_AFS_FEEDBACK, `${PATH_AFS_FEEDBACK}${PATH_THANKS}`],
        component: AFSFeedback
    },
    {
        path: `${PATH_AFS_CALCULATOR}/:step?`,
        component: AFSCalculator
    },
    {
        path: [PATH_CHANGE_VEHICLE_OWNER, `${PATH_CHANGE_VEHICLE_OWNER}${PATH_THANKS}`],
        component: ChangeVehicleOwner
    },
    {
        path: [`${PATH_DEALER_OFFER}/:offerName`, `${PATH_DEALER_OFFER}/:offerName${PATH_THANKS}`],
        component: DealerOffer
    },
    {
        path: [`${PATH_F1_ENQUIRY}/:offerName`, `${PATH_F1_ENQUIRY}/:offerName${PATH_THANKS}`],
        component: F1Enquiry
    },
    {
        path: PATH_RECALL_TAKATA,
        component: RecallForm
    },
    {
        path: PATH_LOCATEADEALER,
        component: LocateADealer
    },
    {
        path: PATH_LOCATEAREPAIRCENTRE,
        component: LocateARepairer
    },
    {
        path: PATH_LOCATETRADEPART,
        component: LocateTradePart
    },
    {
        path: [
            "/promotion/:slug", "/event/:slug", "/competition/:slug",
            `/promotion/:slug${PATH_THANKS}`, `/event/:slug${PATH_THANKS}`, `/competition/:slug${PATH_THANKS}`
        ],
        component: DynamicForm
    },
    {
        path: "/video/:videoType/:videoId",
        component: VideoWidget
    },
    {
        path: PATH_BUY_SERVICE_PLAN,
        component: BuyServicePlan
    },
    {
        path: PATH_TRADEIN,
        component: TradeIn
    },
    {
      path: PATH_EV_RYI,
      component: EVRegisterInterest
    },
    {
      path: PATH_3G,
      component: ThreeG
    },
    {
      path: "/f1-ryi",
      component: F1RyiForm
    }
];
export default routeConfig;
